import React from 'react'
import styled, { keyframes } from 'styled-components'

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const StyledSVG = styled.svg<{ size: string; stroke?: string }>`
  animation: 2s ${rotate} linear infinite;
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  path {
    stroke: ${({ stroke, theme }) => stroke ?? theme.primary1};
  }
`

/**
 * Takes in custom size and stroke for circle color, default to primary color as fill,
 * need ...rest for layered styles on top
 */
export default function Loader({
  size = '16px',
  stroke,
  ...rest
}: {
  size?: string
  stroke?: string
  [k: string]: any
}) {
  return (
    <StyledSVG viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" version="1.1" size={size} stroke={stroke} {...rest}>
      <path d="M12.3371 4.84903C13.7185 4.84903 14.8383 3.76354 14.8383 2.42452C14.8383 1.08549 13.7185 0 12.3371 0C10.9557 0 9.83594 1.08549 9.83594 2.42452C9.83594 3.76354 10.9557 4.84903 12.3371 4.84903Z" fill="#FFE925"/>
      <path opacity="0.92" d="M9.21763 2.64247C9.864 3.7049 9.47056 5.09423 8.37454 5.69355C7.27852 6.32011 5.84527 5.93872 5.227 4.87629C4.58063 3.81387 4.97407 2.42454 6.07009 1.82522C7.16611 1.19866 8.57126 1.58004 9.21763 2.64247Z" fill="#FFE925"/>
      <path opacity="0.84" d="M4.55249 5.55724C5.5923 6.15656 5.95764 7.43693 5.36748 8.47211C4.74921 9.48006 3.42837 9.8342 2.36045 9.26213C1.32064 8.66281 0.955303 7.38244 1.54547 6.34726C2.16373 5.31207 3.51268 4.95793 4.55249 5.55724Z" fill="#FFE925"/>
      <path opacity="0.76" d="M4.11901 12.8339C4.38374 11.7505 3.69233 10.6642 2.57468 10.4075C1.45703 10.1509 0.336378 10.8212 0.0716387 11.9045C-0.193101 12.9879 0.498319 14.0742 1.61597 14.3309C2.73362 14.5875 3.85427 13.9173 4.11901 12.8339Z" fill="#FFE925"/>
      <path opacity="0.68" d="M5.35935 17.8268C5.64313 16.8102 5.02299 15.7631 3.97423 15.488C2.92547 15.2129 1.84523 15.814 1.56144 16.8306C1.27766 17.8473 1.8978 18.8944 2.94656 19.1695C3.99532 19.4446 5.07556 18.8434 5.35935 17.8268Z" fill="#FFE925"/>
      <path opacity="0.6" d="M5.59253 20.0501C6.09838 19.1784 7.25061 18.8788 8.1499 19.3963C9.0492 19.8867 9.35833 21.0036 8.82438 21.8753C8.31852 22.7471 7.1663 23.0467 6.267 22.5291C5.39581 22.0388 5.08667 20.9219 5.59253 20.0501Z" fill="#FFE925"/>
      <path opacity="0.52" d="M10.5665 22.2841C10.5665 21.3306 11.3534 20.5679 12.337 20.5679C13.3206 20.5679 14.1075 21.3306 14.1075 22.2841C14.1075 23.2376 13.3206 24.0003 12.337 24.0003C11.3534 24.0003 10.5665 23.2376 10.5665 22.2841Z" fill="#FFE925"/>
      <path opacity="0.44" d="M16.0468 21.7663C15.5971 21.0035 15.8501 20.0228 16.6369 19.587C17.4238 19.1511 18.4355 19.3963 18.8852 20.1591C19.3348 20.9218 19.0819 21.9025 18.295 22.3384C17.5081 22.7743 16.4964 22.5291 16.0468 21.7663Z" fill="#FFE925"/>
      <path opacity="0.36" d="M20.4309 18.6061C19.7002 18.1975 19.4473 17.2712 19.8689 16.5629C20.2904 15.8547 21.2459 15.6095 21.9766 16.0181C22.7073 16.4267 22.9602 17.353 22.5386 18.0612C22.1171 18.7695 21.1897 19.0147 20.4309 18.6061Z" fill="#FFE925"/>
      <path opacity="0.28" d="M22.5946 13.7572C23.3862 13.7572 24.0279 13.1352 24.0279 12.3678C24.0279 11.6005 23.3862 10.9785 22.5946 10.9785C21.8031 10.9785 21.1614 11.6005 21.1614 12.3678C21.1614 13.1352 21.8031 13.7572 22.5946 13.7572Z" fill="#FFE925"/>
      <path opacity="0.2" d="M21.8642 8.49971C21.2459 8.85385 20.4309 8.63592 20.0656 8.0366C19.7003 7.43728 19.9251 6.64727 20.5434 6.29313C21.1616 5.93898 21.9766 6.15692 22.342 6.75624C22.7073 7.35556 22.5106 8.14557 21.8642 8.49971Z" fill="#FFE925"/>
      <path opacity="0.12" d="M17.7692 4.89078C18.4132 4.72122 18.7935 4.07766 18.6186 3.45336C18.4437 2.82906 17.7798 2.46042 17.1357 2.62999C16.4917 2.79955 16.1114 3.44311 16.2863 4.06741C16.4613 4.69171 17.1252 5.06035 17.7692 4.89078Z" fill="#FFE925"/>
    </StyledSVG>
  )
}
